import { useState, useTransition } from "react";
import { useNavigate as useRouter } from "../../router";
import { Button } from "../../button";
import { apiCall } from "../../api/client";
import {
  hiringJobs,
  type JobShape,
} from "../../api/contracts/hiring-jobs";

interface Props {
  job: JobShape;
}

export function JobActionsBar({ job }: Props) {
  const router = useRouter();
  const [pending, startTransition] = useTransition();
  const [error, setError] = useState<string | null>(null);

  function run(action: "publish" | "unpublish" | "close" | "reopen") {
    setError(null);
    startTransition(async () => {
      try {
        if (action === "publish") {
          await apiCall(hiringJobs.publish, { params: { id: job.id } });
        } else if (action === "unpublish") {
          await apiCall(hiringJobs.update, {
            params: { id: job.id },
            body: { is_public: false },
          });
        } else if (action === "close") {
          await apiCall(hiringJobs.close, {
            params: { id: job.id },
            body: { reason: "closed via UI" },
          });
        } else if (action === "reopen") {
          await apiCall(hiringJobs.update, {
            params: { id: job.id },
            body: { status: "open" },
          });
        }
        router.refresh();
      } catch (err) {
        setError(err instanceof Error ? err.message : "Action failed.");
      }
    });
  }

  const isPublic = job.is_public === 1;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {job.status === "closed" ? (
        <Button
          variant="outline"
          disabled={pending}
          onClick={() => run("reopen")}
        >
          Reopen
        </Button>
      ) : (
        <>
          {isPublic ? (
            <Button
              variant="outline"
              disabled={pending}
              onClick={() => run("unpublish")}
            >
              Unpublish
            </Button>
          ) : (
            <Button disabled={pending} onClick={() => run("publish")}>
              Publish
            </Button>
          )}
          <Button
            variant="outline"
            disabled={pending}
            onClick={() => run("close")}
          >
            Close
          </Button>
        </>
      )}
      {error ? <span className="type-body text-destructive">{error}</span> : null}
    </div>
  );
}
